module.exports = __webpack_public_path__ + "f33be1b165c49be34e8591671e8a2357.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/purse.png
// module id = 3041
// module chunks = 0